const eventStreamSdks = [
  {
    name: '.NET',
    codeSnippets: [
      {
        code: `using RudderStack;
      RudderAnalytics.Initialize(
          WRITE_KEY,
          new RudderConfig(dataPlaneUrl: DATA_PLANE_URL)
      );`,
      },
    ],
  },
  {
    name: 'AMP',
    codeSnippets: [
      {
        code: `<amp-analytics config="https://cdn.rudderlabs.com/amp/rudderstack.json">
      <script type="application/json">
        {
          "vars": {
            "writeKey": WRITE_KEY,
            "dataPlaneUrl": DATA_PLANE_URL,
            "pageName": "Your Page Name"
          }
        }
      </script>
    </amp-analytics>`,
      },
    ],
  },
  {
    name: 'Android',
    codeSnippets: [
      {
        language: 'Kotlin',
        code: `val rudderClient = RudderClient.getInstance(
          this,
          WRITE_KEY,
          RudderConfig.Builder()
              .withDataPlaneUrl(DATA_PLANE_URL)
              .withTrackLifecycleEvents(true)
              .withRecordScreenViews(true)
              .build()
      )`,
      },
      {
        language: 'Java',
        code: `RudderClient rudderClient = RudderClient.getInstance(
              this,
              WRITE_KEY,
              new RudderConfig.Builder()
                      .withDataPlaneUrl(DATA_PLANE_URL)
                      .withTrackLifecycleEvents(true)
                      .withRecordScreenViews(true)
                      .build()
      );`,
      },
    ],
  },
  {
    name: 'Cordova',
    codeSnippets: [
      {
        code: `RudderClient.initialize(WRITE_KEY , {
        dataPlaneUrl: DATA_PLANE_URL,
        loglevel: RudderClient.LogLevel.VERBOSE,
      })`,
      },
    ],
  },
  {
    name: 'Flutter',
    codeSnippets: [
      {
        code: `final RudderController rudderClient = RudderController.instance;
      RudderLogger.init(RudderLogger.VERBOSE);
      RudderConfigBuilder builder = RudderConfigBuilder();
      builder.withDataPlaneUrl(DATA_PLANE_URL);
      builder.withTrackLifecycleEvents(true);
      rudderClient.initialize(WRITE_KEY,config: builder.build());`,
      },
    ],
  },
  {
    name: 'Go',
    codeSnippets: [
      {
        code: `package main
      
      import (
          "github.com/rudderlabs/analytics-go"
      )
      
      func main() {
          // Instantiates a client to use send messages to the Rudder API.
          client := analytics.New(WRITE_KEY, DATA_PLANE_URL)
      
          // Enqueues a track event that will be sent asynchronously.
          client.Enqueue(analytics.Track{
              UserId: "test-user",
              Event:  "test-snippet",
          })
      
          // Flushes any queued messages and closes the client.
          client.Close()
      }`,
      },
    ],
  },
  {
    name: 'iOS',
    codeSnippets: [
      {
        language: 'Objective-C',
        code: `gBuilder *builder = [[RSConfigBuilder alloc] init];
      [builder withDataPlaneUrl:DATA_PLANE_URL];
      [RSClient getInstance:WRITE_KEY config:[builder build]];`,
      },
      {
        language: 'Swift',
        code: `let builder: RSConfigBuilder = RSConfigBuilder()
      .withDataPlaneUrl(DATA_PLANE_URL)
  RSClient.getInstance(WRITE_KEY, config: builder.build())`,
      },
    ],
  },
  {
    name: 'Java',
    codeSnippets: [
      {
        code: `
    RudderAnalytics analytics = RudderAnalytics.builder(
            WRITE_KEY,
            DATA_PLANE_URL
    ).build();`,
      },
    ],
  },
  {
    name: 'Javascript',
    codeSnippets: [
      {
        code: `<script type="text/javascript">
!function(){var e=window.rudderanalytics=window.rudderanalytics||[];e.methods=["load","page","track","identify","alias","group","ready","reset","getAnonymousId","setAnonymousId"],e.factory=function(t){return function(){var r=Array.prototype.slice.call(arguments);return r.unshift(t),e.push(r),e}};for(var t=0;t<e.methods.length;t++){var r=e.methods[t];e[r]=e.factory(r)}e.loadJS=function(e,t){var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.rudderlabs.com/v1.1/rudder-analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a)},e.loadJS(),
e.load(WRITE_KEY,DATA_PLANE_URL),
e.page()}();
</script>`,
      },
    ],
  },
  {
    name: 'Node',
    codeSnippets: [
      {
        code: `const Analytics = require("@rudderstack/rudder-sdk-node")
    
    // RudderStack requires the batch endpoint of the server you are running
    const client = new Analytics(WRITE_KEY, DATA_PLANE_URL / v1 / batch)`,
      },
    ],
  },
  {
    name: 'Python',
    codeSnippets: [
      {
        code: `import rudder_analytics
    
    rudder_analytics.write_key = WRITE_KEY
    rudder_analytics.data_plane_url = DATA_PLANE_URL`,
      },
    ],
  },
  {
    name: 'PHP',
    codeSnippets: [
      {
        code: `require_once("/path/to/lib/Rudder.php");
    
    Rudder::init(WRITE_KEY, array(
      "data_plane_url" => DATA_PLANE_URL,
      "consumer"       => "lib_curl", // fork_curl
      "debug"          => true,
      "max_queue_size" => 10000,
      "batch_size"     => 100,
      "ssl"            => true // defaults to true
    ));`,
      },
    ],
  },
  {
    name: 'React Native',
    codeSnippets: [
      {
        code: `
    await rudderClient.setup(WRITE_KEY, {
      dataPlaneUrl: DATA_PLANE_URL,
      trackLifecycleEvents: true,
      recordScreenViews: true,
    })`,
      },
    ],
  },
  {
    name: 'Ruby',
    codeSnippets: [
      {
        code: `require 'rudder_analytics_sync'

  Analytics = RudderAnalyticsSync::Client.new(
    write_key: WRITE_KEY, # required
    data_plane_url: DATA_PLANE_URL
    on_error: proc { |error_code, error_body, exception, response|
      # defaults to an empty proc
    }
  )`,
      },
    ],
  },
  {
    name: 'Rust',
    codeSnippets: [
      {
        code: `use rudderanalytics::client::RudderAnalytics;

    let rudder_analytics = RudderAnalytics::load(
        "WRITE_KEY".to_string(),
        "DATA_PLANE_URL".to_string()
    );`,
      },
    ],
  },
  {
    name: 'Unity',
    codeSnippets: [
      {
        code: `
        // Critical for iOS Applications where multiple components are using SQLite
        // This has no effect for Android, but can be added as a safety check
        RudderClient.SerializeSqlite();
        
        // Build your config
        RudderConfigBuilder configBuilder = new RudderConfigBuilder()
            .WithDataPlaneUrl(DATA_PLANE_URL);
            .WithLogLevel(RudderLogLevel.VERBOSE)
        
        // get instance for RudderClient
        RudderClient rudderClient = RudderClient.GetInstance(
            WRITE_KEY,
            configBuilder.Build()
        );`,
      },
    ],
  },
];

export type ICodeSnippet = { language?: string; code: string };

export default eventStreamSdks;
